import _extends from "@babel/runtime-corejs3/helpers/extends";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import React, { useState, useEffect } from 'react';
import ControlledTabs from './controlled';

function Tabs(_ref) {
  var _items$;

  var items = _ref.items,
      rest = _objectWithoutProperties(_ref, ["items"]);

  var _useState = useState(items === null || items === void 0 ? void 0 : (_items$ = items[0]) === null || _items$ === void 0 ? void 0 : _items$.name),
      _useState2 = _slicedToArray(_useState, 2),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  function handleChange(_ref2) {
    var name = _ref2.name;
    setActiveTab(name);
  }

  useEffect(function () {
    if (!_findInstanceProperty(items).call(items, function (item) {
      return item.name === activeTab;
    })) {
      var _items$2;

      setActiveTab(items === null || items === void 0 ? void 0 : (_items$2 = items[0]) === null || _items$2 === void 0 ? void 0 : _items$2.name);
    }
  }, [activeTab, items]);
  return /*#__PURE__*/React.createElement(ControlledTabs, _extends({
    items: items,
    activeTab: activeTab,
    onChange: handleChange
  }, rest));
}

export default Tabs;